import { render } from "./Saica.view.vue?vue&type=template&id=1c596872&scoped=true&ts=true"
import script from "./Saica.view.vue?vue&type=script&lang=ts"
export * from "./Saica.view.vue?vue&type=script&lang=ts"

import "./Saica.view.vue?vue&type=style&index=0&id=1c596872&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c596872"]])

export default __exports__